/**
 * ポートレートモード（/portrait）用の固定プロンプトと入力例
 */

/** 常に先頭に付与する本人性保持プロンプト */
export const PORTRAIT_BASE_PROMPT = `Use the uploaded photo only as the identity reference for the subject, preserving their facial features, apparent age, skin tone, hairstyle, hair color, facial hair, and recognizable identity.

Do not copy the clothing, background, pose, or setting from the uploaded photo. Use it only to preserve the subject’s identity and appearance.`;

/** 入力欄のプレースホルダー（プロ向けの例文） */
export const PORTRAIT_PROMPT_PLACEHOLDER = `Preserve the subject’s identity, facial features, apparent age, skin tone, hairstyle, body proportions, clothing, accessories, and overall appearance from the reference photo.

Pose the subject naturally seated on a simple dark wooden stool, with the entire body visible from head to toe. Keep the expression relaxed, warm, and natural.

Use a clean white studio background with soft diagonal window-light shadows. Lighting should be soft, flattering, and realistic.

Create a modern, minimal, high-end editorial portrait with natural skin texture, realistic anatomy, detailed clothing, and professional photography quality.`;

export function buildPortraitPrompt(userPrompt: string): string {
  const trimmed = userPrompt.trim();
  if (!trimmed) {
    return PORTRAIT_BASE_PROMPT;
  }
  return `${PORTRAIT_BASE_PROMPT}\n\n${trimmed}`;
}
